import React from "react";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { CalendarPicker } from "@mui/x-date-pickers/CalendarPicker";
import dayjs from "dayjs";

const FamilyChecklistDatePickerDialog = ({ open, onClose, value, maxDate, onChange }) => {
  const selectedDate = dayjs(value);
  const maxSelectableDate = dayjs(maxDate);

  return (
    <Dialog className="family-checklist-date-dialog" open={open} onClose={onClose} maxWidth="xs" fullWidth PaperProps={{ className: "family-checklist-date-dialog-paper family-checklist-date-picker-paper" }}>
      <DialogContent className="family-checklist-date-dialog-content family-checklist-date-picker-content">
        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <CalendarPicker
            className="family-checklist-date-picker"
            date={selectedDate.isValid() ? selectedDate : dayjs()}
            onChange={(nextDate) => {
              if (!nextDate || !nextDate.isValid()) {
                return;
              }
              onChange(nextDate.format("YYYY-MM-DD"));
              onClose();
            }}
            maxDate={maxSelectableDate.isValid() ? maxSelectableDate : undefined}
            disableFuture
            sx={{
              width: "100%",
              "& .MuiPickersCalendarHeader-label": {
                fontWeight: 700,
                color: "#3d2c1e",
              },
              "& .MuiPickersDay-root.Mui-selected": {
                backgroundColor: "#dd8f1d",
                "&:hover": { backgroundColor: "#c77e18" },
                "&:focus": { backgroundColor: "#dd8f1d" },
              },
              "& .MuiPickersDay-root:not(.Mui-selected)": {
                color: "#3d2c1e",
              },
              "& .MuiPickersDay-today:not(.Mui-selected)": {
                borderColor: "#dd8f1d",
              },
              "& .MuiIconButton-root": {
                color: "#dd8f1d",
              },
            }}
          />
        </LocalizationProvider>
      </DialogContent>
    </Dialog>
  );
};

export default FamilyChecklistDatePickerDialog;
